import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserPreferences } from "packages/lib-utils";

export interface UserPreferencesState {
  preferences: IUserPreferences[];
  error: boolean;
}
const initialState: UserPreferencesState = {
  preferences: [],
  error: false,
};
export const UserPreferencesSlice = createSlice({
  name: "UserPreferences",
  initialState,
  reducers: {
    setPreferences: (state, action) => {
      state.preferences = action.payload;
      state.error = false;
    },
    setPreferencesError: (state) => {
      state.error = true;
      state.preferences = [];
    },
    resetPreferences: (state) => {
      state.preferences = initialState.preferences;
      state.error = initialState.error;
    },
  },
});

export const {
  setPreferences,
  resetPreferences,
  setPreferencesError,
} = UserPreferencesSlice.actions;
export default UserPreferencesSlice.reducer;
